import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { ToastrService } from "ngx-toastr";
import { take } from "rxjs/operators";
import { AppFlowService } from "../services/app-flow/app-flow.service";
import { clientConfig } from "../constant/app.constant";
import { DeliveryOptionsService, ShippingType } from "../services/delivery-options.service";

@Injectable({
  providedIn: "root",
})
export class DeliveryOptionsRouteGuard  {
  constructor(
    private router: Router,
    private store: Store<AppState>,
    private toaster: ToastrService,
    private appFlowService: AppFlowService,
    private deliveryOptionsService: DeliveryOptionsService
  ) {}
  // eslint-disable-next-line unused-imports/no-unused-vars-ts
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const collectionpoint = [];
    const shippingOption = clientConfig.SHIPPING_OPTIONS.dropOffServiceCenter;
    const appFlow = this.appFlowService.getActiveAppFlow();
    const parent = next.parent.routeConfig.path;
    const current = appFlow.sequence.find((s) => s.path === next.routeConfig.path);
    if (shippingOption) {
      shippingOption.filter((i) => {
        collectionpoint.push(i.collectionPointNetwork);
        collectionpoint.push(i.collectionPointCarrier);
      });
    }

    let order: any;
    this.store
      .pipe(select("returnOrder"))
      .pipe(take(1))
      .subscribe((ro) => {
        order = ro;
      });
    const type = order.deliveryOption.deliveryOptionCarrier;

    if (collectionpoint.includes(type)) {
      return true;
    }
    if (order && order.deliveryOption && order.deliveryOption.type) {
      const type = this.deliveryOptionsService.getTypeByMode(order.deliveryOption.type);
      if (type === ShippingType.DropOffStore) {
        return true;
      } else if (type === ShippingType.Collection) {
        if (order.deliveryOption.date && order.deliveryOption.time) {
          return true;
        }
        // this.toaster.error(
        //   "Delivery Option Selection",
        //   "Please select Date & Time"
        // );
        return this.router.parseUrl(`${parent}/${current.back}`);
      }
    } else {
      // no items selected
      // this.toaster.error(
      //   "Delivery Option Selection",
      //   "Please select delivery option"
      // );
      return this.router.parseUrl(`${parent}/${current.back}`);
    }
  }
}
